export const GET_DATA = "GET_DATA";
export const POST_DATA = "POST_DATA";
export const DELETE_DATA = "DELETE_DATA";
export const PUT_DATA = "PUT_DATA";
export const SET_IS_HIDE = "SET_IS_HIDE";
